import { FC, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark, prism } from 'react-syntax-highlighter/dist/cjs/styles/prism';

import color from 'atoms/colors/colors';

import Container from 'quarks/Container';
import Text from 'quarks/Text';
import { BasicProps } from 'quarks/interpolations/basic';

interface CodeSnippetProps extends BasicProps {
  isDark: boolean;
  node: any;
}

const CodeSnippets: FC<CodeSnippetProps> = ({ isDark, node }) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <Container
      position="relative"
      fontSize="textMd"
      paddingX={16}
      paddingY={16}
      md={{ fontSize: 'textMd' }}
      backgroundColorForce={isDark ? '#061B2E' : color.common.white}
      borderRadius="8px"
      border={`1px solid ${isDark ? '#3F4754' : color.storm[50]}`}
      marginBottom={24}
      css={{
        '.token': {
          '&:not(.punctuation)': {
            color: isDark ? color.algae[300] : '#8E5FBE',
          },
        },
      }}
    >
      <SyntaxHighlighter
        language={node.language}
        useInlineStyles={false}
        style={isDark ? atomDark : prism}
        customStyle={{
          padding: '0',
          backgroundColor: isDark ? '#061B2E!important' : color.common['white'],
          textAlign: 'left',
          overflowX: 'auto',
        }}
        codeTagProps={{
          style: {
            color: isDark ? '#1eb7cc' : '#016aa4',
          },
        }}
      >
        {node.code}
      </SyntaxHighlighter>
      <CopyToClipboard text={node.code} onCopy={handleCopy}>
        <Text
          position="unset"
          top="16px"
          right="16px"
          borderRadius="8px"
          backgroundColor="storm-50"
          fontSize="textSm"
          paddingX={8}
          paddingY={4}
          width="100%"
          display="block"
          textColor="storm-900"
          cursor="pointer"
          marginTop={16}
          sm={{ width: 'auto', position: 'absolute', marginTop: 0 }}
          lg={{
            paddingX: 16,
            paddingY: 8,
            fontSize: 'textLg',
          }}
        >
          {isCopied ? 'Copied' : 'Copy'}
        </Text>
      </CopyToClipboard>
    </Container>
  );
};

export default CodeSnippets;
